import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const GetChatAttributesModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.getChatAttributes,
  templateType: ModuleTemplateTypeEnum.tools,
  isTool: true,
  flowType: FlowNodeTypeEnum.getChatAttributes,
  avatar: '/imgs/module/cfr.svg',
  name: '获取自定义属性',
  description: '获取该聊天客户的某个属性',
  inputs: [
    Input_Template_Switch,
    {
      key: ModuleInputKeyEnum.chatId,
      type: FlowNodeInputTypeEnum.hidden,
      label: 'chatId',
      valueType: ModuleIOValueTypeEnum.string,
      value: '{chatId}',
    },
    {
      key: ModuleInputKeyEnum.attributes,
      type: FlowNodeInputTypeEnum.custom,
      label: '属性key',
      description: '',
      valueType: ModuleIOValueTypeEnum.fieldDescription,
      required: true,
    },
  ],
  outputs: [
    Output_Template_Finish,
    {
      key: ModuleOutputKeyEnum.attributes,
      type: FlowNodeOutputTypeEnum.source,
      label: '属性',
      valueType: ModuleIOValueTypeEnum.kv,
      targets: [],
    },
  ],
};
